import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import logger from 'utils/logger.util';

const L = logger('inspectError');

const inspectError = (error) => {
  const { message, code } = error ?? {};

  if (!(error instanceof Error) && !message) {
    L.warn('()', 'Invalid error:', error);
  }

  return Object.freeze({
    //
    ok: false,
    //
    created: code === 201,
    noContent: code === 204,
    forbidden: code === 403,
    notFound: code === 404,
    methodNotAllowed: code === 405,
    //
    withMessage: fromAnyToBool(fromAnyToTrimmed(message)),
    withCode: fromAnyToBool(fromAnyToTrimmed(code)),
  });
};

// noinspection JSUnusedGlobalSymbols
export default inspectError;
